import React, { useState } from "react";
import lesClubs from "./quizzes/les_clubs.json";
import clubEcologie from "./quizzes/club_ecologie.json";
import cultureGenerale from "./quizzes/culture_generale.json";
import clubHumanitaire from "./quizzes/club_humanitaire.json";
import "./QuizLFIT.css";

const categories = {
  "Les Clubs": ["Facile", "Moyen", "Difficile"],
  "Le Club Écologie":  ["Facile", "Moyen", "Difficile"],
  "Culture Générale": ["Facile", "Moyen", "Difficile"],
  "Le Club Humanitaire": ["Facile", "Moyen", "Difficile"]
};

// Associe les fichiers JSON aux catégories
const quizFiles = {
  "Les Clubs": lesClubs,
  "Le Club Écologie": clubEcologie,
  "Culture Générale": cultureGenerale,
  "Le Club Humanitaire": clubHumanitaire
};

const QuizLFIT = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [quizStarted, setQuizStarted] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [quizEnded, setQuizEnded] = useState(false);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSelectedLevel(null);
    setQuizStarted(false);
  };

  const startQuiz = (level) => {
    setSelectedLevel(level);
    const data = quizFiles[selectedCategory];

    if (!data) {
      console.error(`Aucun fichier trouvé pour la catégorie: ${selectedCategory}`);
      return;
    }

    const filteredQuestions = data.filter(q => !level || q.difficulty === level);
    setQuestions(filteredQuestions.sort(() => 0.5 - Math.random()).slice(0, 5));
    setQuizStarted(true);
    setCurrentQuestion(0);
    setScore(0);
    setQuizEnded(false);
  };

  const handleAnswerClick = (option) => {
    const correctAnswer = questions[currentQuestion]?.answer;
    if (option === correctAnswer) {
      setScore(prevScore => prevScore + 10); // Ajoute 10 points par bonne réponse
    }

    if (currentQuestion + 1 < questions.length) {
      setCurrentQuestion(prev => prev + 1);
    } else {
      setQuizEnded(true);
    }
  };

  return (
    <div className="quiz-lfit-container">
      <div className="quiz-lfit-sidebar">
        <h2>Menu Quiz</h2>
        <ul>
          {Object.keys(categories).map(category => (
            <li key={category}>
              <button onClick={() => handleCategoryClick(category)}>{category}</button>
            </li>
          ))}
        </ul>
      </div>

      <div className="quiz-lfit-main">
        {!selectedCategory ? (
          <h1>Choisissez une catégorie de Quiz</h1>
        ) : !selectedLevel ? (
          <div>
            <h1>{selectedCategory}</h1>
            <p>Choisissez un mode :</p>
            <div className="quiz-lfit-levels">
              {categories[selectedCategory].map(level => (
                <button key={level} onClick={() => startQuiz(level)}>{level}</button>
              ))}
            </div>
          </div>
        ) : quizEnded ? (
          <div>
            <h1>🎉 Quiz Terminé ! 🎉</h1>
            <p>Score final : {score}</p>
            <button onClick={() => setQuizStarted(false)}>Rejouer</button>
          </div>
        ) : (
          <div>
            <h1>Quiz - {selectedCategory} ({selectedLevel})</h1>
            <p>Score : {score}</p>
            <h2>{questions[currentQuestion]?.question}</h2>
            <div className="quiz-lfit-answers">
              {questions[currentQuestion]?.options.map((option, index) => (
                <button key={index} onClick={() => handleAnswerClick(option)}>
                  {option}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizLFIT;